/*
 * TyphoonMart custom scripts (株式会社タイフーンマート 案件共通の追加 JavaScript)
 *
 * Theme: Prestige 11.4.0
 * Created: 2026-09-22
 *
 * Prestige標準JavaScript（assets/theme.js 等）は直接変更せず、標準機能で実現できない挙動だけをここに追加する。
 * layout/theme.liquid で c_custom.css の後に defer で読み込む。
 * ルールは CLAUDE.md 第6章・第6.1章に従う。グローバル変数は追加しない。
 */

/*
 * Wishlist Guru：ヘッダーのお気に入り件数の同期
 *
 * アプリは画面幅が 1024px 以下／以上に変わるたびにヘッダーのハート（PC 用 .wg-prestige-headerIcon-desktop、
 * SP 用 .wg-prestige-headerIcon-mobile）を切り替え、SP 用が無ければ件数欄（.count-span）が空の要素を新しく作る。
 * 件数はお気に入りの追加・削除とページ読み込みの時点で「その時点にある .count-span」にだけ書き込まれるため、
 * リロードせずに幅を変えると、新しく作られた SP 用のハートに件数が表示されない。
 * アプリが作ったヘッダーのハートに空の件数欄があるとき、アプリが書き込んだもう一方の件数欄の内容を写す。
 * 件数そのものはアプリが数えた値を使い、ここでは数え直さない。
 */
(() => {
  const countSelector = '.header__secondary-nav :is(.wg-prestige-headerIcon-desktop, .wg-prestige-headerIcon-mobile) .count-span';

  const syncWishlistCount = () => {
    const countSpans = [...document.querySelectorAll(countSelector)];
    const source = countSpans.find((countSpan) => countSpan.querySelector('.show-count'));

    if (!source) {
      return;
    }

    countSpans.forEach((countSpan) => {
      if (!countSpan.querySelector('.show-count')) {
        countSpan.innerHTML = source.innerHTML;
      }
    });
  };

  // ヘッダーのハート（またはその件数欄）が追加されたときだけ同期する。
  // body を監視するため、テーマエディタでヘッダー section が再読み込みされても動作する。
  const isWishlistHeaderNode = (node) =>
    node.nodeType === Node.ELEMENT_NODE &&
    (node.matches('[class*="wg-prestige-headerIcon"], .count-span') ||
      node.querySelector('[class*="wg-prestige-headerIcon"]'));

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some(isWishlistHeaderNode))) {
      syncWishlistCount();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  syncWishlistCount();
})();

/*
 * 会員登録キャンペーンのポップアップ（sections/c_campaign-popup.liquid）：Escape キーで閉じる
 *
 * Prestige 標準のポップアップ（pop-in）はフォーカスを閉じ込めない非モーダルの表示で、
 * 閉じる操作は閉じるボタン（Tab で移動して Enter／Space）だけになる。
 * キーボードだけでも閉じやすいよう、開いている間は Escape でも閉じる。
 * 開閉・1 回だけ表示する制御は標準の newsletter-popup 要素の処理をそのまま使う。
 * document に 1 度だけ登録するため、テーマエディタで section が再読み込みされても重複しない。
 */
(() => {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    const popup = document.querySelector('.c_campaign-popup[open]');

    if (popup && typeof popup.hide === 'function') {
      popup.hide();
    }
  });
})();

/*
 * クーポン案内のポップアップ（sections/c_campaign-popup.liquid のログイン済み・購入履歴なしの表示）：表示の制御
 *
 * 対象は data-c-coupon-popup が付いた pop-in 要素（Prestige 標準の開閉だけを持つ要素）。
 * 未ログイン向けの会員登録案内は標準の newsletter-popup 要素のままで、ここでは扱わない。
 *   - section 設定の秒数（data-delay）が過ぎたら 1 回だけ開く
 *   - 開いた日時を localStorage に保存し、設定の日数（data-suppress-days、既定 30 日）が過ぎるまで開かない。
 *     閉じたときではなく開いたときに保存するため、閉じずに別のページへ移動しても繰り返し表示しない
 *   - 保存キーは未ログイン向け（標準の theme:popup-appeared）とは別で、顧客 ID ごとに分ける。
 *     未ログインのときに会員登録案内を閉じていても、ログイン後のクーポン案内は表示される
 *   - 購入履歴のあるお客様には要素自体が出力されない（Liquid 側で判定）
 * localStorage が使えない環境では保存できないため、ページごとに表示される。
 * テーマエディタで section が再読み込みされた場合も、新しい要素に対して 1 度だけ予約する。
 */
(() => {
  const STORAGE_PREFIX = 'c:coupon-popup-shown:';
  const DAY = 24 * 60 * 60 * 1000;
  const scheduled = new WeakSet();

  const readShownAt = (key) => {
    try {
      return Number(localStorage.getItem(key)) || 0;
    } catch (error) {
      return 0;
    }
  };

  const schedule = (popup) => {
    if (scheduled.has(popup)) {
      return;
    }

    scheduled.add(popup);

    const key = STORAGE_PREFIX + (popup.dataset.customer || 'customer');
    const suppressDays = Number(popup.dataset.suppressDays) || 30;
    const delay = (Number(popup.dataset.delay) || 0) * 1000;

    if (Date.now() - readShownAt(key) < suppressDays * DAY) {
      return;
    }

    setTimeout(() => {
      // 待っている間に別のタブで表示済みになった場合は開かない
      if (!popup.isConnected || typeof popup.show !== 'function' || Date.now() - readShownAt(key) < suppressDays * DAY) {
        return;
      }

      popup.show();

      try {
        localStorage.setItem(key, String(Date.now()));
      } catch (error) {
        // 保存できない環境では、ページごとに表示される
      }
    }, delay);
  };

  const scheduleAll = () => document.querySelectorAll('pop-in[data-c-coupon-popup]').forEach(schedule);

  customElements.whenDefined('pop-in').then(() => {
    scheduleAll();
    document.addEventListener('shopify:section:load', scheduleAll);
  });
})();

/*
 * 初回購入クーポンの案内（snippets/c_coupon-notice.liquid）：クーポンコードのコピー
 *
 * 「コードをコピー」ボタン（data-c-coupon-copy）を押すと、同じ案内の中のコード（data-c-coupon-code）を
 * クリップボードへコピーし、結果を案内の中の欄（data-c-coupon-status、role="status"）に表示する。
 * クリップボード API が使えない・拒否された場合は従来の方法（一時的な入力欄）を試し、
 * それも失敗したときは、コードの文字を選択した状態にして手動でコピーできるようにする。
 * ボタンは button 要素のため、Tab で移動して Enter／Space でも操作できる。
 * document への委譲で 1 度だけ登録するため、商品詳細・カートの再描画やテーマエディタでの再読み込み後も動作し、重複しない。
 */
(() => {
  const copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch (error) {
        // 権限やフォーカスの都合で拒否された場合は、下の従来の方法を試す
      }
    }

    // クリップボード API がない・使えない環境：一時的な入力欄を選択してコピーする
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.insetBlockStart = '0';
    field.style.opacity = '0';
    document.body.append(field);
    field.select();

    try {
      if (!document.execCommand('copy')) {
        throw new Error('copy command was rejected');
      }
    } finally {
      field.remove();
    }
  };

  const selectContents = (element) => {
    const range = document.createRange();
    range.selectNodeContents(element);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  };

  const statusTimers = new WeakMap();

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const button = event.target.closest('[data-c-coupon-copy]');
    const notice = button?.closest('.c_coupon-notice');
    const codeElement = notice?.querySelector('[data-c-coupon-code]');
    const status = notice?.querySelector('[data-c-coupon-status]');
    const code = codeElement?.textContent.trim();

    if (!code || !status) {
      return;
    }

    clearTimeout(statusTimers.get(status));

    try {
      await copyToClipboard(code);
      status.textContent = button.dataset.copiedText;
      statusTimers.set(status, setTimeout(() => (status.textContent = ''), 4000));
    } catch (error) {
      selectContents(codeElement);
      status.textContent = button.dataset.failedText;
    }
  });
})();
